import { useState } from 'react'
import { Text, VStack, Table, Tr, Tbody, Td, Link } from '@chakra-ui/react'
import { useMonthlyCourseUnregister } from '@!/User/MonthlyCourseUnregister/hooks/useMonthlyCourseUnregister'
import { CircularProgressModal, YesNoPopupModal } from '@!/components/Modal'

const MonthlyCourseUnregister = ({ registers }) => {
  const { executeUnregister, isUnregistering } = useMonthlyCourseUnregister()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedOrderId, setSelectedOrderId] = useState(null)
  const [settlementType, setSettlementType] = useState(null)

  const handleUnregister = (orderId, settlementType) => {
    setSelectedOrderId(orderId)
    setSettlementType(settlementType)
    setIsModalOpen(true)
  }

  const handleConfirmUnregister = () => {
    if (selectedOrderId && settlementType) {
      executeUnregister(selectedOrderId, settlementType)
    }
    setIsModalOpen(false)
    setSelectedOrderId(null)
    setSettlementType(null)
  }

  const handleCancelUnregister = () => {
    setIsModalOpen(false)
    setSelectedOrderId(null)
    setSettlementType(null)
  }

  return (
    <VStack minH="50vh" spacing={4} py={8} justifyContent="space-between">
      <VStack spacing={4} w="full">
        <Text fontSize="2xl" fontWeight="semibold" pb={2}>
          月額解除ページ
        </Text>
        <Text fontSize="xs">{registers && registers.length > 0 ? '以下の月額コースに登録しています。' : '月額コースに登録していません。'}</Text>
        {registers && registers.length > 0 && (
          <Table width="full" variant="simple" borderTopWidth="1px">
            <Tbody>
              {registers.map((register, index) => (
                <Tr key={`monthly-course-unregister-${index}`}>
                  <Td fontWeight="600" fontSize="xs" lineHeight="20px">
                    {register.monthly_course_name}
                  </Td>
                  <Td textAlign="center" fontWeight="600" fontSize="xs" lineHeight="20px">
                    <Link onClick={() => handleUnregister(register.order_id, register.settlement_type)} data-gtm-subscription={`cancel_${register.amount}`}>
                      解除
                    </Link>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </VStack>
      <Link href="/" fontSize="xs">
        トップに戻る
      </Link>
      <CircularProgressModal isOpen={isUnregistering} />
      <YesNoPopupModal
        title={'登録を解除します。よろしいですか？'}
        handleCancel={handleCancelUnregister}
        handleSubmit={handleConfirmUnregister}
        cancelTitle={'キャンセル'}
        submitTitle={'はい'}
        isOpen={isModalOpen}
      />
    </VStack>
  )
}

export default MonthlyCourseUnregister
